/**
 * Abstract class that contains the action that the supervisor user can do
 */

import {QuotationService, QuotationServiceActionType} from '../../../../services/quotation.service';
import {Subject} from 'rxjs';
import {MessageManagerService} from '@shared/service/message-manager/message-manager.service';
import {QuotationListInfoModel} from '../../../../models/quotation-list-info.model';
import {CommonActions} from './common-actions';
import {DossierWorkingWoe, WorkingActions, WorkingTypes} from '../../../../models/enums.model';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {WorkingModel} from '../../../../models/working.model';
import {LoaderService} from '@shared/service/loader.service';
import {DossierModel} from 'app/authority/authority-shared/models/dossier.model';
import {AuthorityForcedChannelingDialogComponent} from '../../../../../authority-ald/components/authority-forced-channeling-dialog/authority-forced-channeling-dialog.component';
import {AuthorityChannelingService, ForcedChannelingRequest} from '../../../../services/authority-channeling.service';
import {InnerMessageAuthorityMessageCode} from '../../../../services/inner-message-authority-utilities';
import {MessageComponentType, MessageType} from '@shared/service/message-manager/message.model';
import {MessageManagerUtilities} from '@shared/service/message-manager/message-manager-utilities';

export abstract class SupervisorActions extends CommonActions {

	static superApprove(quotationService: QuotationService, loaderService: LoaderService, messageManagerService: MessageManagerService, needRefreshDossierSubject: Subject<void>,
						dossierId: string, workingId: string, allQuotations: QuotationListInfoModel): void {
		this.doQuotationPatch(
			quotationService, loaderService, dossierId, workingId, allQuotations, needRefreshDossierSubject, messageManagerService, QuotationServiceActionType.SUPER_APPROVE
		);
	}

	static cancelSuperReject(
		dossier: DossierModel, dialog: MatDialog, quotationService: QuotationService, loaderService: LoaderService, needRefreshDossierSubject: Subject<void>, messageManagerService: MessageManagerService,
		dossierId: string, working: WorkingModel, allQuotations: QuotationListInfoModel): void {
		const callback: () => void = () => this.doQuotationPatch(quotationService, loaderService, dossierId, working.id, allQuotations, needRefreshDossierSubject, messageManagerService, QuotationServiceActionType.CANCEL_SUPER_REJECT);
		if (working.dossierWorkingQualification === DossierWorkingWoe.CONTRACT_EXPIRED || working.dossierWorkingQualification === DossierWorkingWoe.WRECK) {
			CommonActions.openConfirmActionDialog(dossier.flowType, dialog, WorkingActions.CANCEL_SUPER_REJECT, callback, `Stai per annullare il blocco della pratica ${working.working_number_prefix}`);
		} else {
			callback();
		}
	}

	static downloadWoePdf(quotationService: QuotationService, messageManagerService: MessageManagerService, dossier: DossierModel, workingId: string, allQuotations: QuotationListInfoModel): void {
		quotationService.downloadWoePdf(dossier, workingId, allQuotations.quotations[0].id,
			errorMessage => messageManagerService.pushInnerMessage(errorMessage));
	}

	static forcedChanneling(
		working: WorkingModel, 
		dialog: MatDialog, 
		authorityChannelingService: AuthorityChannelingService, 
		messageManagerService: MessageManagerService, 
		loaderService: LoaderService, 
		needRefreshDossierSubject: Subject<void>,
		
		// parametri inutili - da togliere
		forcedChannelingWorkings: { workingId: string, workingType?: WorkingTypes }[], 
		workingTypes: WorkingTypes[]
	): void {
		const dialogConfig: MatDialogConfig = new MatDialogConfig<any>();
		dialogConfig.height = 'auto';
		dialogConfig.width = 'auto';
		dialogConfig.backdropClass = 'amd-dialog__backdrop--dark';
		dialogConfig.panelClass = 'amd-full-screen-simple-table-dialog';

		const matDialogRef: MatDialogRef<AuthorityForcedChannelingDialogComponent> = dialog.open(AuthorityForcedChannelingDialogComponent, dialogConfig);

		matDialogRef.afterClosed().subscribe(result => {
			if (!!result) {
				loaderService.display(true);

				authorityChannelingService.forceChanneling2([working], result.group.user_group, result.user, working.isArchived(), false).subscribe(() => {
					messageManagerService.pushInnerMessage({
						code: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_CHANNELLING,
						componentType: MessageComponentType.FLASH_MESSAGE,
						type: MessageType.TYPE_SUCCESS
					});
					needRefreshDossierSubject.next();
				}, error => {
					messageManagerService.pushInnerMessage(MessageManagerUtilities.getMessageDetailsFromResponse(error));
					loaderService.display(false);
				});

				return;

				// const requestBody: ForcedChannelingRequest = authorityChannelingService.getRequestForForcedChanneling(result, forcedChannelingWorkings, workingTypes);
				// authorityChannelingService.forceChanneling(requestBody).subscribe(() => {
				// 	messageManagerService.pushInnerMessage({
				// 		code: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_CHANNELLING,
				// 		componentType: MessageComponentType.FLASH_MESSAGE,
				// 		type: MessageType.TYPE_SUCCESS
				// 	});
				// 	needRefreshDossierSubject.next();
				// }, error => {
				// 	messageManagerService.pushInnerMessage(MessageManagerUtilities.getMessageDetailsFromResponse(error));
				// 	loaderService.display(false);
				// });
			}
		});
	}
}
